query GetEventYouTubeSessions($eventId: ID!) {
  sessions: StreamToolsGetEventYouTubeSessions(eventId: $eventId) {
    sessionId
    eventId
    scope
    status
    startedAt
    stoppedAt
    stopReason
    channelId
    channelTitle
    videoId
    channelProfileImageUrl
    foreignEvent
  }
}
